import * as React from 'react';

import { Col, Input, Row, Select } from 'antd';

import { WebhookStatus } from 'v2/interfaces/webhook2';

import { useWebhookContext } from '../context';

function Filter() {
  const { filter, setFilter, webhooks } = useWebhookContext();

  const handleChangeField = (name: string, value: string) => {
    setFilter({ ...filter, [name]: value });
  };

  const hasWebhooks = webhooks?.length > 0;

  return (
    <Row gutter={16} justify='end' id='webhook-filters'>
      <Col xs={24} md={8}>
        <div className='flex flex-col gap-1'>
          <label className='text-sm text-gray-600'>URL/Nome</label>
          <Input
            placeholder='Pesquise por URL ou nome'
            id='url_webhook'
            onChange={e => handleChangeField('url', e.target.value)}
            disabled={!hasWebhooks}
          />
        </div>
      </Col>
      <Col xs={24} md={4}>
        <div className='flex flex-col gap-1'>
          <label className='text-sm text-gray-600'>Status</label>
          <Select
            id='status'
            className='w-full'
            value={filter.status}
            onChange={value => handleChangeField('status', value)}
            disabled={!hasWebhooks}
            options={[
              { label: 'Todos', value: 'all' },
              { label: 'Ativo', value: `${WebhookStatus.active.toString()}` },
              { label: 'Inativo', value: `${WebhookStatus.inactive.toString()}` },
              { label: 'Com erro', value: `${WebhookStatus.failing.toString()}` }
            ]}
          />
        </div>
      </Col>
      <Col xs={24} md={4}>
        <div className='flex flex-col gap-1'>
          <label className='text-sm text-gray-600'>Tipo</label>
          <Select
            id='type'
            className='w-full'
            value={filter.type}
            onChange={value => handleChangeField('type', value)}
            disabled={!hasWebhooks}
            options={[
              { label: 'Todos', value: 'all' },
              { label: 'Fatura', value: 'invoice' },
              { label: 'Abandono de Carrinho', value: 'abandonment' }
            ]}
          />
        </div>
      </Col>
    </Row>
  );
}

export { Filter };
